export enum MachineRequestType {
	StillageRequired = 0,
	SupervisorRequired = 10
}